<div class="layout-margin" fxLayout="column" fxLayoutGap="16px">
  <div class="balance">
    <pr-balance-display [balance]="balance$ | async" />
  </div>
  <pr-invoice-transactions
    [invoice]="invoice$ | async"
    [appointmentRef]="appointmentRef"
    [appointment]="appointment"
    [autoApplyAppointmentAccountCredits]="autoApplyAppointmentAccountCredits"
  />
</div>
